module.exports = __webpack_public_path__ + "img/buddy_nose-04.12ac5cc0.svg";